import React from "react"
import Helmet from "react-helmet"

const siteRoute = "https://usby.us"

export const SEO = ({
  pagePath,
  metaInfo,
}: {
  pagePath: string
  metaInfo: {
    metaTitle?: string
    metaDescription?: string
    openImageUrl?: string
    twitterImageUrl?: string
    twitterTitle?: string
    openTitle?: string
    openGraphDescription?: string
    twitterDescription?: string
  }
}) => {
  const title = metaInfo
    ? metaInfo.metaTitle
      ? metaInfo.metaTitle
      : "USBYUS"
    : "USBYUS"
  const metaDescription = metaInfo
    ? metaInfo.metaDescription
      ? metaInfo.metaDescription
      : "USBYUS is dedicated to selling limited edition prints, clothing, and accessories. starting out focusing on providing art accessible to both novice to established investors. USBYUS sells the highest-quality products at modest prices."
    : "USBYUS is dedicated to selling limited edition prints, clothing, and accessories. starting out focusing on providing art accessible to both novice to established investors. USBYUS sells the highest-quality products at modest prices."
  const metaKeywords = "USBYUS, art, clothing, prints"
  const ogImage = metaInfo
    ? metaInfo.openImageUrl
      ? metaInfo.openImageUrl
      : "https://usby.us/open.jpg"
    : "https://usby.us/open.jpg"
  const twitterImage = metaInfo
    ? metaInfo.twitterImageUrl
      ? metaInfo.twitterImageUrl
      : "https://usby.us/open.jpg"
    : "https://usby.us/open.jpg"
  const openTitle = metaInfo
    ? metaInfo.openTitle
      ? metaInfo.openTitle
      : title
    : title
  const openGraphDescription = metaInfo
    ? metaInfo.openGraphDescription
      ? metaInfo.openGraphDescription
      : metaDescription
    : metaDescription
  const twitterTitle = metaInfo
    ? metaInfo.twitterTitle
      ? metaInfo.twitterTitle
      : title
    : title
  const twitterDescription = metaInfo
    ? metaInfo.twitterDescription
      ? metaInfo.twitterDescription
      : metaDescription
    : metaDescription
  return (
    <Helmet title={title}>
      <html lang="en" />
      <meta http-equiv="Accept-CH" content="DPR, Width, Viewport-Width" />
      <meta property="og:locale" content="en_US" />
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      <meta
        property="og:url"
        content={`${siteRoute}/${pagePath ? pagePath : ""}`}
      />
      <meta property="og:image" content={ogImage} />
      <meta property="og:title" content={`${openTitle}`} />
      <meta property="og:site_name" content="USBYUS" />
      <meta property="og:description" content={openGraphDescription} />
      <meta name="twitter:site" content="@USBYUS" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={`${twitterTitle}`} />
      <meta name="twitter:image:src" content={twitterImage} />
      <meta name="twitter:description" content={twitterDescription} />
      <meta
        name="twitter:url"
        content={`${siteRoute}/${pagePath ? pagePath : ""}`}
      />
    </Helmet>
  )
}
